<pai-carousel [interval]="data().interval ?? 0" [data]="data().testimonials" class="testimonials">
  <ng-template paiCarouselItem let-item>
    <pai-cmp-testimonial [data]="item" />
  </ng-template>
</pai-carousel>
